// extracted by mini-css-extract-plugin
export default {"container":"wWGm62DYF0zx9I4T14gQ","mainContent":"mqqkPkaQ5zczXS1vQFgU"};